import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import RefundPage from './RefundPage';
import { PageWithNavigation } from '../../components';

// const ns = 'refunds';

/**
 * Refunds Page RefundPage
 */
export default () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Refunds</title>
      </Helmet>
      <PageWithNavigation>
        <RefundPage t={t} useSelector={useSelector} type="cashew" />
      </PageWithNavigation>
    </>
  );
};
